import { AlertCircle } from 'lucide-react';

import { useMatter } from '@/hooks/useMatter';
import { enhancedApi } from '@/services/api/generated/filevineSyncService';
import { useGetMatterDetailsQuery } from '@/services/api/mattersService';

import { CMSLinkBadge } from '../matter-title/badges';
import { NeosSyncUpdates } from '../neos-sync';
import { FilevineSyncUpdates } from './FilevineSyncUpdates';

export { FilevineCreateNoteAction } from './FilevineCreateNoteAction';
export { FilevineSyncActionItem } from './FilevineSyncActionItem';
export { FilevineSyncPlanCard } from './FilevineSyncPlanCard';
export { FilevineSyncUpdates } from './FilevineSyncUpdates';
// Bad place for this I should move i t

export const SyncUpdates = () => {
  const { matterId } = useMatter();
  const { data: matter } = useGetMatterDetailsQuery(matterId);

  // guess the cms system
  const { data: cmsSystem, isLoading } = enhancedApi.useCmsGuessCmsSystemQuery({
    matterId,
  });

  if (isLoading || !cmsSystem?.cms_system) {
    return null;
  }

  const cmsSystemName = cmsSystem.cms_system;
  const externalCmsUrl = cmsSystem.external_cms_url;

  // Show warning if no external CMS URL is set
  if (!externalCmsUrl && matter) {
    return (
      <div className="flex flex-col h-full">
        <div className="flex items-center justify-between mb-4">
          <span className="text-2xl font-semibold">{cmsSystemName} Sync</span>
        </div>
        <div className="border border-orange-300 bg-orange-50 rounded-md p-6">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-orange-600 mt-0.5 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-sm font-medium text-orange-800 mb-1">
                External CMS URL Required
              </p>
              <p className="text-sm text-orange-700 mb-3">
                To sync with {cmsSystemName}, you need to add the external CMS
                URL for this matter. This URL links this matter to its
                corresponding case in {cmsSystemName}.
              </p>
              <div className="flex gap-2">
                <CMSLinkBadge
                  matterId={matter.id}
                  cmsUrl={matter.external_cms_url}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (cmsSystemName === 'Filevine') {
    return <FilevineSyncUpdates />;
  }

  if (cmsSystemName === 'Neos') {
    return <NeosSyncUpdates />;
  }

  return null;
};
